import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import SafeIcon from '../common/SafeIcon';
// import * as FiIcons from 'react-icons/fi';

// const { FiArrowRight } = FiIcons;

const PaigePage = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

  return (
    <div className="min-h-screen bg-white pt-16">
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
            className="text-center"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-6xl font-bold mb-8 leading-tight font-serif"
            >
              About Me
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-black-200 mb-10 leading-relaxed max-w-3xl mx-auto"
            >
              I help people build and launch real-world applications using AI.
            </motion.p>
          </motion.div>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
          >
            <p className="text-lg text-black-700 leading-relaxed mb-6">
              With a background in software development and AI, I'm passionate about making technology accessible to everyone. My courses are designed to be practical, hands-on, and focused on real-world projects.
            </p>
            <p className="text-lg text-black-700 leading-relaxed mb-6">
              I believe that anyone can learn to build applications with the right guidance and tools. My goal is to empower students to turn their ideas into reality.
            </p>
            <Link to="/courses">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-black-900 text-white rounded-lg font-semibold text-lg hover:bg-black-800 transition-colors shadow-lg flex items-center gap-2"
              >
                <span>Explore My Courses</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
  */
};

export default PaigePage;